'use strict';

angular.module('imagetrend.components')
    .directive('hlpFormBuilderQuestionList', [function () {
        return {
            restrict: 'AE',
            scope: {
                form: '=?',
                component: '=?',
                question: '=?',
                index: '@?'
            },
            controller: ['$scope', function ($scope) {
                $scope.$watch('form.allDisabled', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.question.disabled = $scope.form.allDisabled;
                    }
                });
                $scope.$watch('form.allUpdateFromForm', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.question.update_from_form = $scope.form.allUpdateFromForm;
                    }
                });
                $scope.$watch('form.allShowInGrid', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.question.show_in_grid = $scope.form.allShowInGrid;
                    }
                });
                $scope.$watch('form.allRequired', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.question.required = $scope.form.allRequired;
                    }
                });
                $scope.applicationTypeExists = function (question) {
                    var exists = false;
                    if (question.data_point_code == 'certification_levels') {
                        $scope.component.questions.forEach(function (q) {
                            if (q.question_type.code == 'application_type') {
                                $scope.question.required = q.required;
                                $scope.question.disabled = q.disabled;
                                $scope.question.update_from_form = q.update_from_form;
                                exists = true;
                            }
                        })
                    }

                    return exists;
                }
            }],

            replace: true,
            transclude: true,
            templateUrl: 'templates/form-builder/form-builder-question-list/form-builder-question-list.html',
            link: function (scope, elem, attrs, ctrl) {

            }
        };
    }])
;